package com.neurobs.ccabserver.administrator.view

import com.neurobs.ccab.CommState
import com.neurobs.js.dom.{ButtonButton, Grid}
import com.neurobs.js.dom.Grid._
import org.scalajs.dom.raw.HTMLElement
import scalatags.JsDom.all._
import com.neurobs.js.dom.ElementFactory._

class CommStatusView {
	private val grid = new Grid(fullWidth = false, emGapSize = 0.5, defaultAlign = Grid.alignCenter)
	private var comm: Option[CommState] = None
	private var volume: Option[Double] = None
	private var volumeControls: Boolean = false
	val volumeUpButton = ButtonButton(makeButton(caption = "+", `class` = Some("controller-session-subject-volume-button")))
	val volumeDownButton = ButtonButton(makeButton(caption = "-", `class` = Some("controller-session-subject-volume-button")))

	val container: HTMLElement = {
		div(`class` := "video-chat-comm-status", grid.container).render
		//panel.container
	}

	private def update(): Unit = {
		def cap(prefix: String, audio: Boolean, video: Boolean): String = {
			val value =
				if (audio && video) "Audio+Video"
				else if (audio) "Audio"
				else "Video"
			s"$prefix: $value"
		}

		grid.clear()
		grid.addRow(span(style := "white_space: nowrap;", b("Test Station A/V")).render)
		volume foreach { v =>
			val row = span(input(`type` := "range", min := 0, max := 100, style := "width:8em;", disabled := true, value := v * 100)).render
			if (volumeControls) {
				row.appendChild(volumeDownButton.button)
				row.appendChild(volumeUpButton.button)
			}
			grid.addRow(row)
		}
		comm foreach { state =>
			if (state.allOff) grid.addRow(span("Off").render)
			else {
				if (state.audio_out || state.video_out) {
					grid.addRow(span(style := "white-space: nowrap;", cap(prefix = "Out", audio = state.audio_out, video = state.video_out)).render)
				}
				if (state.audio_in || state.video_in) {
					grid.addRow(span(style := "white-space: nowrap;", cap(prefix = "In", audio = state.audio_in, video = state.video_in)).render)
					grid.addRow(span(style := "white-space: nowrap;", s"(${state.source_name})").render)
				}
			}
		}
	}

	def update(volume: Option[Double], volumeControls: Boolean): Unit = {
		if ((this.volume != volume) || (this.volumeControls != volumeControls)) {
			this.volume = volume
			this.volumeControls = volumeControls
			update()
		}
	}

	def update(state: CommState, volumeControls: Boolean): Unit = {
		if ((comm != Some(state)) || (this.volumeControls != volumeControls)) {
			comm = Some(state)
			this.volumeControls = volumeControls
			update()
		}
	}
}
